import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../../lib/api";
import { toast, Toaster } from "sonner";

export default function AgenziaPasswordReset() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token") || "";
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (newPw.length < 8) { setError("La password deve avere almeno 8 caratteri"); return; }
    if (newPw !== confirm) { setError("Le due password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/agency/auth/password-reset/confirm", { token, new_password: newPw });
      setDone(true);
      toast.success("Password reimpostata. Puoi accedere.");
      setTimeout(() => nav("/area-agenzie/login"), 1500);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Impossibile reimpostare la password");
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen paper-bg flex items-center justify-center p-8" data-testid="agenzia-reset-page">
        <div className="max-w-md w-full text-center">
          <div className="label-uppercase text-[#B3261E] mb-3">Link non valido</div>
          <h1 className="font-serif text-3xl mb-3">Manca il token di reset</h1>
          <p className="text-sm text-[#5C5657] mb-6">Il link ricevuto sembra incompleto. Richiedi un nuovo link dalla pagina di login.</p>
          <Link to="/area-agenzie/login" className="btn-primary inline-block">Vai al login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen paper-bg flex items-center justify-center p-8" data-testid="agenzia-reset-page">
      <Toaster position="top-right" richColors />
      <div className="max-w-md w-full">
        <div className="label-uppercase mb-4">Area Agenzie Partner</div>
        <h1 className="font-serif text-4xl mb-2">Nuova password</h1>
        <p className="text-sm text-[#5C5657] mb-10">Imposta la nuova password del tuo accesso Area Agenzie. Minimo 8 caratteri.</p>
        {done ? (
          <div className="border border-[#E6E4E0] bg-white p-6" data-testid="agenzia-reset-done">
            <div className="label-uppercase text-[#7D2E3F] mb-2">Fatto</div>
            <p className="text-sm text-[#3A3D42]">Password aggiornata. Ti stiamo portando al login…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-6">
            <div>
              <label className="label-uppercase">Nuova password</label>
              <input required type="password" minLength={8} value={newPw}
                     data-testid="agenzia-reset-new"
                     onChange={(e) => setNewPw(e.target.value)}
                     className="editorial-input" autoFocus />
            </div>
            <div>
              <label className="label-uppercase">Conferma nuova password</label>
              <input required type="password" minLength={8} value={confirm}
                     data-testid="agenzia-reset-confirm"
                     onChange={(e) => setConfirm(e.target.value)}
                     className="editorial-input" />
            </div>
            {error && <div className="text-xs text-[#B3261E]" data-testid="agenzia-reset-error">{error}</div>}
            <button type="submit" disabled={loading} data-testid="agenzia-reset-submit" className="btn-primary w-full">
              {loading ? "Salvo…" : "Imposta nuova password"}
            </button>
            <Link to="/area-agenzie/login" className="block text-xs text-center text-[#5C5657] hover:text-[#7D2E3F]">← Torna al login</Link>
          </form>
        )}
      </div>
    </div>
  );
}
